import React, { useState, useEffect, useRef } from 'react'
import {
    getWorkFlowStepsOrderedNew, getListMappedForStepById, getEmailTemplatesList, getsmsTemplatesList, getWhatsappTemplatesList, getNotificationTemplatesList, getCallTemplatesList,
    MapStepsWithTemplate, deleteMappedStepsWithTemplate, DoNotifyById, GetEmailTemplateHTML
} from '../ActionCreator'
import NodataImage from '../../../../../images/nodata.png'

import Loader from '../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../presentationals/Popup/Popup.component'
import Pagination from '@mui/material/Pagination';
import { formatDateNew } from '../../../../../utils/commonUtility';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import systemIcons1 from '../../../../../images/systemIcons1.png'
import systemplan1 from '../../../../../images/systemplan1.png'
import manual1 from '../../../../../images/manual1.png'
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};


const names = [
    'Monday',
    'Tuesday',
    'Wednusday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
    'Everyday'

];


const TabBoxStyle = {
    display: 'flex',
    alignItems: 'start'
}

const circlecss = {

    borderRadius: '50%',
    width: '40px',
    height: '40px',
    padding: '4.5px 4.5px',
    cursor: 'pointer'
}

const StepperLinecss = {
    width: '3px',
    background: '#1eb0d2',
    height: '80px',
    margin: '10px auto'
}

const hours24 = Array.from({ length: 24 }, (_, index) =>
    index.toString().padStart(2, '0') + ':00'
);

const formatTo12Hour = (time24) => {
    const [hour] = time24.split(':');
    const h = parseInt(hour, 10);
    const ampm = h >= 12 ? 'PM' : 'AM';
    const displayHour = h % 12 === 0 ? 12 : h % 12;
    return `${displayHour}:00 ${ampm}`;
};

const itemsPerPage = 10;
export default function Main() {
    const mapRef = useRef(null)
    const [loader, setLoader] = useState(false)
    const [stepSelectedData, setStepSelectedData] = useState({})
    const [stepSelected, setStepSelected] = useState("")
    const [steps, setSteps] = useState([])
    const [selectedListTab, setSelectedListTab] = useState("mapped")
    const [popup, setpopup] = useState({ show: false, popupStatus: "" })
    const [currentPage, setcurrentPage] = useState(1)
    const [popupList, setPopupList] = useState([])
    const [popupTableData, setpopupTableData] = useState([])
    const [previewTemplate, setPreviewTemplate] = useState({ show: false, data: "", selectedata: "", type: "" })
    const [apiData, setApiData] = useState({})
    const [datashow, setdatashow] = useState('')
    const [triggerDate, settriggerDate] = React.useState([]);
    const [mapdata, setMapdata] = useState({
        triggerTime: [],
        executionOrder: 0
    })

    const [mapPopup, setMapPopup] = useState({ show: false, data: {} })

    const handleTriggerDateChange = (event) => {
        const {
            target: { value },
        } = event;
        settriggerDate(
            typeof value === 'string' ? value.split(',') : value,
        );
    };


    useEffect(() => {
        getWorkFlowStepsOrderedFn()

    }, [])

    const handlelistTabselected = (type, da = stepSelectedData) => {
        setSelectedListTab(type)
        setcurrentPage(1);
        if (type == "mapped") {
            getListMappedForStepByIdFn(da)
        } else if (type == "mail") {
            getEmailTemplatesListFn()
        } else if (type == "sms") {
            getsmsTemplatesListFn()
        } else if (type == "whatsapp") {
            getWhatsappTemplatesListFn()
        } else if (type == "notification") {
            getNotificationTemplatesListFn()
        } else if (type == "call") {
            getCallTemplatesListFn()
        }
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: '' })
    }

    const handlePopupPagePagination = (event, value) => {
        setcurrentPage(value);
        const data = filterFunction(popupTableData, value)
        setPopupList(data)
    };

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }
    const handleTabselected = (type) => {
        handlelistTabselected("mapped", type)
        setStepSelectedData(type)
        setStepSelected(type?.stepName)
    }

    const filterFunction = (data, currentPageNo) => {
        const indexOfLastItem = currentPageNo * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = data && data?.length > 0 ? data?.slice(indexOfFirstItem, indexOfLastItem) : [];
        return currentItems

    }

    const getWorkFlowStepsOrderedFn = () => {
        getWorkFlowStepsOrderedNew(callback => {
            console.log(callback)
            if (callback && callback?.message == "success") {
                setApiData(callback?.data)
                // setSteps(callback?.data)
                // setStepSelectedData(callback?.data[0])
                // setStepSelected(callback?.data[0]?.stepName)
                // getListMappedForStepByIdFn(callback?.data[0])
                setSteps([])
                setStepSelectedData({})
                setStepSelected('')
                setdatashow('')
            } else {
                setApiData({})
                setSteps([])
                setStepSelectedData({})
                setStepSelected('')
                setdatashow('')
            }
        })
    }

    const handleTabSelectedcard = (type) => {
        setSelectedListTab("mapped")
        setdatashow(type)
        setSteps([])
        setStepSelectedData({})
        setStepSelected('')
        if (Object.keys(apiData?.[type]) !== null && Object.keys(apiData?.[type])?.length > 0) {
            setSteps(apiData?.[type])
            setStepSelectedData(apiData?.[type]?.[0])
            setStepSelected(apiData?.[type]?.[0]?.stepName)
            getListMappedForStepByIdFn(apiData?.[type]?.[0])
            setTimeout(() => {
                mapRef.current?.scrollIntoView({
                    behavior: 'smooth',
                });
            }, 300)
        }
    }

    const handleMappingValue = (data, type) => {
        if (type == "unmapped") {
            MapStepsWithTemplateFn(data, selectedListTab)
        } else if (type == "mapped") {
            deleteMappedStepsWithTemplateFn(data)
        }
    }

    const handleMApPopup = (type, data) => {
        if (data?.mapped == true) {
            setpopup({ show: true, popupStatus: "Template can't be Unmapped From Here" });
            removePopup()
        } else {

            if (datashow == "SYSTEM") {
                handleMappingValue(data, "unmapped")
            } else {
                setMapPopup({ show: type, data: data })
            }
        }
    }

    const deleteMappedStepsWithTemplateFn = (d) => {

        setLoader(true)
        deleteMappedStepsWithTemplate(d?.mappingId, callback => {
            setLoader(false)
            console.log(callback)
            if (callback && callback?.message == "success") {
                setpopup({ show: true, popupStatus: "Template Unmapped Successfully" })
                getListMappedForStepByIdFn(stepSelectedData)
            } else {
                setpopup({ show: true, popupStatus: "Error Unmapping Template" })
            }
            removePopup()
        })
    }
    const MapStepsWithTemplateFn = (d, selectedListTab) => {
        setMapPopup({ show: false, data: {} })
        const obj = {
            stepId: stepSelectedData?.stepId,
            templateId: selectedListTab === "mail" ? d?.emailId : selectedListTab === "sms" ? d?.smsId : selectedListTab === "whatsapp" ? d?.whatsappId : selectedListTab === "notification" ? d?.notificationId : selectedListTab === "call" ? d?.callId : "",
            templateType: selectedListTab === "mail" ? "EMAIL" : selectedListTab === "sms" ? "SMS" : selectedListTab === "whatsapp" ? "WHATSAPP" : selectedListTab === "notification" ? "NOTIFICATION" : selectedListTab === "call" ? "CALL" : "",


        }
        if (datashow == "SYSTEM_PLAN") {
            obj["triggerTime"] = mapdata?.triggerTime?.join(", ")
            obj["triggerDay"] = triggerDate[0]
        }
        if (datashow == "SYSTEM") {
            obj["executionOrder"] = 0;
        }
        if (datashow == "MANUAL") {
            obj["executionOrder"] = mapdata?.executionOrder;
        }
        console.log("obj", obj)
        setLoader(true)
        MapStepsWithTemplate(obj, callback => {
            setLoader(false)
            console.log(callback, callback?.message)
            settriggerDate([])
            setMapdata({ triggerTime: [], executionOrder: 0 })
            if (callback && callback?.message == "success" && callback?.data == "mapping already exist") {
                setpopup({ show: true, popupStatus: "Template is already Mapped" })
                getListMappedForStepByIdFn(stepSelectedData)
            } else if (callback && callback?.message == "success") {
                setpopup({ show: true, popupStatus: "Template Mapped Successfully" })
                if (selectedListTab == "mail") {
                    getEmailTemplatesListFn()
                } else if (selectedListTab == "sms") {
                    getsmsTemplatesListFn()
                } else if (selectedListTab == "whatsapp") {
                    getWhatsappTemplatesListFn()
                } else if (selectedListTab == "notification") {
                    getNotificationTemplatesListFn()
                } else if (selectedListTab == "call") {
                    getCallTemplatesListFn()
                }
            } else {
                setpopup({ show: true, popupStatus: "Error Mapping Template" })
            }
            removePopup()
        })
    }
    const getListMappedForStepByIdFn = (data) => {
        setLoader(true)
        getListMappedForStepById(data?.stepId, callback => {
            setLoader(false)
            console.log(callback)
            if (callback && callback?.message == "success") {
                setpopupTableData(callback?.data)
                setcurrentPage(1);
                const data = filterFunction(callback?.data, 1)
                setPopupList(data)
            } else {
                setpopupTableData([])
                setPopupList([])
            }
        })
    }
    const getEmailTemplatesListFn = () => {
        setLoader(true)
        const id = "?stepId=" + stepSelectedData?.stepId;
        getEmailTemplatesList(id, callback => {
            setLoader(false)
            console.log(callback)
            if (callback && callback?.message == "success") {
                setpopupTableData(callback?.data)
                setcurrentPage(1);
                const data = filterFunction(callback?.data, 1)
                setPopupList(data)
            } else {
                setpopupTableData([])
                setPopupList([])
            }
        })
    }
    const getsmsTemplatesListFn = () => {
        setLoader(true)
        const id = "?stepId=" + stepSelectedData?.stepId;
        getsmsTemplatesList(id, callback => {
            setLoader(false)
            console.log(callback)
            if (callback && callback?.message == "success") {
                setpopupTableData(callback?.data)
                setcurrentPage(1);
                const data = filterFunction(callback?.data, 1)
                setPopupList(data)
            } else {
                setpopupTableData([])
                setPopupList([])
            }
        })
    }
    const getWhatsappTemplatesListFn = () => {
        setLoader(true)
        const id = "?stepId=" + stepSelectedData?.stepId;
        getWhatsappTemplatesList(id, callback => {
            setLoader(false)
            console.log(callback)
            if (callback && callback?.message == "success") {
                setpopupTableData(callback?.data)
                setcurrentPage(1);
                const data = filterFunction(callback?.data, 1)
                setPopupList(data)
            } else {
                setpopupTableData([])
                setPopupList([])
            }
        })
    }
    const getNotificationTemplatesListFn = () => {
        setLoader(true)
         const id = "?stepId=" + stepSelectedData?.stepId;
        getNotificationTemplatesList(id, callback => {
            setLoader(false)
            console.log(callback)
            if (callback && callback?.message == "success") {
                setpopupTableData(callback?.data)
                setcurrentPage(1);
                const data = filterFunction(callback?.data, 1)
                setPopupList(data)
            } else {
                setpopupTableData([])
                setPopupList([])
            }
        })
    }
    const getCallTemplatesListFn = () => {
        setLoader(true)
        const id = "?stepId=" + stepSelectedData?.stepId;
        getCallTemplatesList(id, callback => {
            setLoader(false)
            console.log(callback)
            if (callback && callback?.message == "success") {
                setpopupTableData(callback?.data)
                setcurrentPage(1);
                const data = filterFunction(callback?.data, 1)
                setPopupList(data)
            } else {
                setpopupTableData([])
                setPopupList([])
            }
        })
    }

    const handleNotify = () => {
        setLoader(true)
        DoNotifyById(stepSelectedData?.stepId, "yogesh", callback => {
            setLoader(false)
            console.log(callback)
            if (callback == "success") {
                setpopup({ show: true, popupStatus: 'Message Send Successfully' })
            } else {
                setpopup({ show: true, popupStatus: 'Error Sending Message' })
            }
            removePopup()
        })
    }

    const GetEmailTemplateHTMLFn = (type, data) => {
        setLoader(true)
        GetEmailTemplateHTML(data?.fileId, callback => {
            setLoader(false)
            console.log(callback, "ca")
            if (callback && callback == "file not found") {
                setPreviewTemplate({ show: false, data: "", nameOfFile: "", type: "" })
                setpopup({ show: true, popupStatus: "File Not Found" })
            } else {
                setPreviewTemplate({ show: true, data: callback, selectedata: data, type: type })
            }
            removePopup()
        })
    }

    const handlePreviewOption = (type, data) => {
        if (type == "mapped") {

        } else if (type == "mail") {
            GetEmailTemplateHTMLFn(type, data)
        } else {
            setPreviewTemplate({ show: true, data: "", selectedata: data, type: type })
        }
    }

    const handleTriggerTimeChange = (event) => {
        const {
            target: { value },
        } = event;
        setMapdata((prev)=>({
            ...prev,
            triggerTime : typeof value === 'string' ? value.split(', ') : value
        }))
      
    }

    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            {
                popup?.show ?
                    <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
                    : ""
            }
            <div className="container-fluid CommModulecss" style={{ marginTop: '100px' }}>

                <div className="row">
                    <div className="col-sm-4 col-xs-12">
                        <div className='customCardscss'>
                            <div className='blueTheme'>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="Iconcontent">
                                        <img src={systemIcons1} width={"30px"} alt="System Icon" />
                                    </div>

                                    <h5 style={{ fontSize: '30px', fontWeight: '700', color: '#1d4ed8' }}>
                                        {apiData && Object.keys(apiData)?.length > 0 && apiData?.SYSTEM ? apiData?.SYSTEM?.length : 0}
                                    </h5>
                                </div>
                                <h3
                                    className={`cardsheadings ${datashow == "SYSTEM" ? "active" : ''}`}
                                    style={{
                                        fontSize: "18px",
                                        fontWeight: '600',
                                        color: '#1e3a8a',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => handleTabSelectedcard("SYSTEM")}
                                >
                                    System <ArrowRightIcon />
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4 col-xs-12">
                        <div className='customCardscss'>
                            <div className='greenTheme'>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="Iconcontent">
                                        <img src={systemplan1} width={"30px"} alt="System Plan Icon" />
                                    </div>
                                    {/* Fixed: Use .length instead of Object.keys().length for arrays */}
                                    <h5 style={{ fontSize: '30px', fontWeight: '700', color: '#22723d' }}>
                                        {apiData && Object.keys(apiData)?.length > 0 && apiData?.SYSTEM_PLAN ? apiData?.SYSTEM_PLAN?.length : 0}
                                    </h5>
                                </div>
                                <h3
                                    className={`cardsheadings ${datashow == "SYSTEM_PLAN" ? "active" : ''}`}
                                    style={{
                                        fontSize: "18px",
                                        fontWeight: '600',
                                        color: '#22723d',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => handleTabSelectedcard("SYSTEM_PLAN")}
                                >
                                    System Plan <ArrowRightIcon />
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4 col-xs-12">
                        <div className='customCardscss'>
                            <div className='purpleTheme'>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="Iconcontent">
                                        <img src={manual1} width={"30px"} alt="Manual Icon" />
                                    </div>
                                    {/* Fixed: Use .length instead of Object.keys().length for arrays */}
                                    <h5 style={{ fontSize: '30px', fontWeight: '700', color: '#653893' }}>
                                        {apiData && Object.keys(apiData)?.length > 0 && apiData?.MANUAL ? apiData?.MANUAL?.length : 0}
                                    </h5>
                                </div>
                                <h3
                                    className={`cardsheadings ${datashow == "MANUAL" ? "active" : ''}`}
                                    style={{
                                        fontSize: "18px",
                                        fontWeight: '600',
                                        color: '#653893',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => handleTabSelectedcard("MANUAL")}
                                >
                                    Manual <ArrowRightIcon />
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    steps && steps?.length > 0 ?

                        <div className="row" style={{ marginTop: '60px' }} ref={mapRef}>
                            <div className="col-sm-2 col-xs-12" style={{ paddingTop: '5px' }}>

                                <div className="LeftTabsSection" style={{ overflowY: steps?.length > 4 ? "auto" : "hidden", height: '480px', overflowX: 'visible', scrollbarWidth: 'thin', margin: '15px 0' }}>
                                    {
                                        steps?.map((value, index) => {
                                            return (
                                                <>
                                                    <div className="TabBox" style={{ ...TabBoxStyle }} key={index}>
                                                        <div>
                                                            <div style={{ ...circlecss, border: stepSelected === value?.stepName ? '3px solid #1eb0d2' : '3px solid grey', color: stepSelected === value?.stepName ? "#fff" : "#1eb0d2" }} onClick={() => handleTabselected(value)}>
                                                                <div style={{
                                                                    width: '25px', height: '25px', borderRadius: '50%', background: stepSelected === value?.stepName ? '#1eb0d2' : "grey"
                                                                }}></div>
                                                            </div>
                                                            {
                                                                index + 1 === steps?.length ? "" :
                                                                    <div style={StepperLinecss}></div>
                                                            }
                                                        </div>
                                                        <div style={{ margin: '5px 0 0 15px', cursor: 'pointer' }} onClick={() => handleTabselected(value)}>
                                                            <h4 style={{ marginTop: '0', fontSize: '16px' }}><b>{value?.stepName}</b></h4>
                                                        </div>
                                                    </div>

                                                </>
                                            )
                                        })
                                    }
                                </div>

                            </div>
                            <div className="col-sm-10 col-xs-12">
                                <div className="RightSideDiv" style={{ boxShadow: 'rgba(50, 71, 92, 0.02) 0px 2px 6px 4px, rgba(50, 71, 92, 0.04) 0px 2px 9px 0px, rgba(0, 0, 0, 0.25) 0px 4px 4px 0px', overflow: 'auto', height: '530px', borderRadius: '12px' }}>
                                    <div className="headertab" style={{ background: 'rgba(0, 108, 103, 0.42)', borderRadius: '12px 12px 0px 0px', padding: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div className='toptabss' style={{ display: 'flex' }}>
                                            <div className="tabsscss" onClick={() => handlelistTabselected("mapped", stepSelectedData)} style={{ borderTopLeftRadius: "12px", borderBottomLeftRadius: "12px", background: selectedListTab === "mapped" ? "#1eb0d2" : "#fff", color: selectedListTab === "mapped" ? "#fff" : "#0e5768" }}>Mapped</div>
                                            <div className="tabsscss" onClick={() => handlelistTabselected("mail", stepSelectedData)} style={{ background: selectedListTab === "mail" ? "#1eb0d2" : "#fff", color: selectedListTab === "mail" ? "#fff" : "#0e5768" }}>Email</div>
                                            <div className="tabsscss" onClick={() => handlelistTabselected("sms", stepSelectedData)} style={{ background: selectedListTab === "sms" ? "#1eb0d2" : "#fff", color: selectedListTab === "sms" ? "#fff" : "#0e5768" }}>SMS</div>
                                            <div className="tabsscss" onClick={() => handlelistTabselected("whatsapp", stepSelectedData)} style={{ background: selectedListTab === "whatsapp" ? "#1eb0d2" : "#fff", color: selectedListTab === "whatsapp" ? "#fff" : "#0e5768" }}>Whatsapp</div>
                                            <div className="tabsscss" onClick={() => handlelistTabselected("notification", stepSelectedData)} style={{  background: selectedListTab === "notification" ? "#1eb0d2" : "#fff", color: selectedListTab === "notification" ? "#fff" : "#0e5768" }}>Notification</div>
                                            <div className="tabsscss" onClick={()=>handlelistTabselected("call")} style={{borderRight: '0', borderTopRightRadius: "12px", borderBottomRightRadius: "12px", background: selectedListTab === "call" ? "#1eb0d2" : "#fff", color: selectedListTab === "call" ? "#fff" : "#0e5768"}}>Call</div>
                                        </div>
                                        <div>
                                            <button className='btn btn-primary' style={{ padding: '10px 15px' }} onClick={() => handleNotify()}>Notify</button>
                                        </div>
                                    </div>
                                    <div className="bodyTab" style={{ padding: '15px' }}>

                                        <div>

                                            {
                                                popupList && popupList?.length > 0 ?
                                                    <>
                                                        <hr />
                                                        <div className="row" style={{ marginTop: '20px' }}>
                                                            <div className="col-xs-12">
                                                                <div className="" style={{ boxShadow: '3px 3px 10px 3px #eee', borderRadius: '0px', marginTop: '0', overflowX: 'auto', position: 'relative', overflowY: 'auto', height: popupList?.length > 8 ? '320px' : "auto" }}>
                                                                    <table className='phocket-table' >
                                                                        <thead style={{ position: 'sticky', top: '0', zIndex: '2' }}>
                                                                            {
                                                                                selectedListTab == "mapped" ?
                                                                                    <tr>
                                                                                        <th className='text-center'>Action</th>
                                                                                        <th className='text-center'>step Id</th>
                                                                                        <th className='text-center'>Description</th>
                                                                                        <th className='text-center'>Template Id</th>
                                                                                        <th className='text-center'>Template Type</th>
                                                                                        <th className='text-center'>Execution Order</th>
                                                                                        <th className='text-center'>Trigger Day</th>
                                                                                        <th className='text-center'>Trigger Time</th>
                                                                                        <th className='text-center'>Added On</th>
                                                                                    </tr>
                                                                                    : ''}
                                                                            {
                                                                                selectedListTab == "mail" ?
                                                                                    <tr>
                                                                                        <th className='text-center'>Action</th>
                                                                                        <th className='text-center'>Details</th>
                                                                                        <th className='text-center'>Subject</th>
                                                                                        <th className='text-center'>Body</th>
                                                                                        <th className='text-center'>Async</th>
                                                                                        <th className='text-center'>Added On</th>
                                                                                    </tr>
                                                                                    : ''}
                                                                            {
                                                                                selectedListTab == "sms" ?
                                                                                    <tr>
                                                                                        <th className='text-center' style={{ minWidth: '150px' }}>Action</th>
                                                                                        <th className='text-center'>Details</th>
                                                                                        <th className='text-center'>DLT Id</th>
                                                                                        <th className='text-center'>Description</th>
                                                                                        <th className='text-center'>Content</th>
                                                                                        <th className='text-center'>Async</th>
                                                                                        <th className='text-center'>Added On</th>
                                                                                    </tr>
                                                                                    : ''}
                                                                            {
                                                                                selectedListTab == "whatsapp" ?
                                                                                    <tr>
                                                                                        <th className='text-center'>Action</th>
                                                                                        <th className='text-center'>Details</th>
                                                                                        <th className='text-center'>DLT Id</th>
                                                                                        <th className='text-center'>Text</th>
                                                                                        <th className='text-center'>Subject</th>
                                                                                        <th className='text-center'>Description</th>
                                                                                        <th className='text-center'>Async</th>
                                                                                        <th className='text-center'>Added On</th>
                                                                                    </tr>
                                                                                    : ''}
                                                                            {
                                                                                selectedListTab == "notification" ?
                                                                                    <tr>
                                                                                        <th className='text-center'>Action</th>
                                                                                        <th className='text-center'>Details</th>
                                                                                        <th className='text-center'>Subject</th>
                                                                                        <th className='text-center'>Text</th>
                                                                                        <th className='text-center'>Description</th>
                                                                                        <th className='text-center'>Async</th>
                                                                                        <th className='text-center'>Added On</th>
                                                                                    </tr>
                                                                                    : ''}
                                                                            {
                                                                                selectedListTab == "call" ?
                                                                                    <tr>
                                                                                        <th className='text-center'>Action</th>
                                                                                       
                                                                                        <th className='text-center'>Template Name</th>
                                                                                        <th className='text-center'>Call Purpose</th>
                                                                                        <th className='text-center'>Campaign Name</th>
                                                                                        <th className='text-center'>Lead Name</th>
                                                                                        <th className='text-center'>Outbound</th>
                                                                                        <th className='text-center'>Added On</th>
                                                                                    </tr>
                                                                                    : ''}
                                                                        </thead>
                                                                        <tbody style={{ borderRadius: '0px' }}>
                                                                            {popupList && popupList?.length > 0 ? popupList?.map((data, i) => (
                                                                                selectedListTab == "mapped" ?
                                                                                    <tr key={i} style={{ borderRadius: '0px' }}>
                                                                                        <td className='text-center' style={{ border: '0px', borderRadius: '0px', padding: '13px' }}>
                                                                                            <div className='custom-switch2' style={{ margin: '10px 0 10px 0px' }}>
                                                                                                <label class="switch">
                                                                                                    <input type="checkbox" class="checkbox"
                                                                                                        checked={true}
                                                                                                        onChange={(e) =>
                                                                                                            handleMappingValue(data, "mapped")
                                                                                                        }
                                                                                                    />
                                                                                                    <div class="slider"></div>
                                                                                                </label>
                                                                                            </div>
                                                                                        </td>
                                                                                        {/* <td className='text-center' style={{ border: '0px' }}>
                                                                                            < InfoOutlinedIcon style={{ cursor: 'pointer' }} onClick={() => handlePreviewOption("mapped", data)} />
                                                                                        </td> */}
                                                                                        <td className='text-center' style={{ border: '0px' }}>{data?.stepId}</td>
                                                                                        <td className='text-center' style={{ border: '0px' }}>{data?.description || ""}</td>
                                                                                        <td className='text-center' style={{ border: '0px' }}>{data?.templateId}</td>
                                                                                        <td className='text-center' style={{ border: '0px' }}>{data?.templateType}</td>
                                                                                        <td className='text-center' style={{ border: '0px' }}>{data?.executionOrder}</td>
                                                                                        <td className='text-center' style={{ border: '0px' }}>{data?.triggerDay || "-"}</td>
                                                                                        <td className='text-center' style={{ border: '0px' }}>{data?.triggerTime || "-"}</td>

                                                                                        <td className='text-center' style={{ border: '0px' }}>{formatDateNew(data?.creationDate)}</td>

                                                                                    </tr>
                                                                                    :
                                                                                    selectedListTab == "mail" ?
                                                                                        <tr key={i} style={{ borderRadius: '0px' }}>
                                                                                            <td className='text-center' style={{ borderRadius: '0px', padding: '13px', border: '0px' }}>
                                                                                                <div className='custom-switch2' style={{ margin: '10px 0 10px 0px' }}>
                                                                                                    <label class="switch">
                                                                                                        <input type="checkbox" class="checkbox"
                                                                                                            checked={data?.mapped}
                                                                                                            onChange={(e) =>
                                                                                                                handleMApPopup(true, data)
                                                                                                            }
                                                                                                        />
                                                                                                        <div class="slider"></div>
                                                                                                    </label>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td className='text-center' style={{ border: '0px' }}>
                                                                                                < InfoOutlinedIcon style={{ cursor: 'pointer' }} onClick={() => handlePreviewOption("mail", data)} />
                                                                                            </td>
                                                                                            <td className='text-center' style={{ border: '0px' }}>{data?.emailSubject}</td>
                                                                                            <td className='text-center' style={{ border: '0px' }}>{data?.emailPath}</td>
                                                                                            <td className='text-center' style={{ border: '0px' }}>{data.async ? "Yes" : "No"}</td>
                                                                                            <td className='text-center' style={{ border: '0px' }}>{formatDateNew(data?.creationDate)}</td>

                                                                                        </tr>
                                                                                        :
                                                                                        selectedListTab == "sms" ?
                                                                                            <tr key={i} style={{ borderRadius: '0px', padding: '13px', borderRadius: '0px' }}>
                                                                                                <td className='text-center' style={{ border: '0px' }}>
                                                                                                    <div className='custom-switch2' style={{ margin: '10px 0 10px 0px' }}>
                                                                                                        <label class="switch">
                                                                                                            <input type="checkbox" class="checkbox"
                                                                                                                checked={data?.mapped}
                                                                                                                onChange={(e) =>
                                                                                                                    handleMApPopup(true, data)
                                                                                                                }
                                                                                                            />
                                                                                                            <div class="slider"></div>
                                                                                                        </label>
                                                                                                    </div>
                                                                                                </td>
                                                                                                <td className='text-center' style={{ border: '0px' }}>
                                                                                                    < InfoOutlinedIcon style={{ cursor: 'pointer' }} onClick={() => handlePreviewOption("sms", data)} />
                                                                                                </td>
                                                                                                <td className='text-center' style={{ border: '0px' }}>{data?.dltId}</td>
                                                                                                <td className='text-center' style={{ border: '0px' }}>{data?.messageDescription}</td>
                                                                                                <td className='text-center' style={{ border: '0px' }}>{data?.messageContent}</td>
                                                                                                <td className='text-center' style={{ border: '0px' }}>{data.async ? "Yes" : "No"}</td>
                                                                                                <td className='text-center' style={{ border: '0px' }}>{formatDateNew(data?.creationDate)}</td>

                                                                                            </tr>
                                                                                            :
                                                                                            selectedListTab == "whatsapp" ?
                                                                                                <tr key={i} style={{ borderRadius: '0px' }}>
                                                                                                    <td className='text-center' style={{ borderRadius: '0px', padding: '13px', border: '0px' }}>
                                                                                                        <div className='custom-switch2' style={{ margin: '10px 0 10px 0px' }}>
                                                                                                            <label class="switch">
                                                                                                                <input type="checkbox" class="checkbox"
                                                                                                                    checked={data?.mapped}
                                                                                                                    onChange={(e) =>
                                                                                                                        handleMApPopup(true, data)
                                                                                                                    }
                                                                                                                />
                                                                                                                <div class="slider"></div>
                                                                                                            </label>
                                                                                                        </div>
                                                                                                    </td>
                                                                                                    <td className='text-center' style={{ border: '0px' }}>
                                                                                                        < InfoOutlinedIcon style={{ cursor: 'pointer' }} onClick={() => handlePreviewOption("whatsapp", data)} />
                                                                                                    </td>
                                                                                                    <td className='text-center' style={{ border: '0px' }}>{data?.dltId}</td>
                                                                                                    <td className='text-center' style={{ border: '0px' }}>{data?.whatsappText}</td>
                                                                                                    <td className='text-center' style={{ border: '0px' }}>{data?.whatsappSubject}</td>
                                                                                                    <td className='text-center' style={{ border: '0px' }}>{data?.whatsappDescription}</td>
                                                                                                    <td className='text-center' style={{ border: '0px' }}>{data.async ? "Yes" : "No"}</td>
                                                                                                    <td className='text-center' style={{ border: '0px' }}>{formatDateNew(data?.creationDate)}</td>

                                                                                                </tr>
                                                                                                :
                                                                                                selectedListTab == "notification" ?
                                                                                                    <tr key={i} style={{ borderRadius: '0px', padding: '13px', borderRadius: '0px' }}>
                                                                                                        <td className='text-center' style={{ border: '0px' }}>
                                                                                                            <div className='custom-switch2' style={{ margin: '10px 0 10px 0px' }}>
                                                                                                                <label class="switch">
                                                                                                                    <input type="checkbox" class="checkbox"
                                                                                                                        checked={data?.mapped}
                                                                                                                        onChange={(e) =>
                                                                                                                            // handleMappingValue(data, "unmapped")
                                                                                                                            handleMApPopup(true, data)
                                                                                                                        }
                                                                                                                    />
                                                                                                                    <div class="slider"></div>
                                                                                                                </label>
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        <td className='text-center' style={{ border: '0px' }}>
                                                                                                            < InfoOutlinedIcon style={{ cursor: 'pointer' }} onClick={() => handlePreviewOption("notification", data)} />
                                                                                                        </td>
                                                                                                        <td className='text-center' style={{ border: '0px' }}>{data?.notificationSubject}</td>
                                                                                                        <td className='text-center' style={{ border: '0px' }}>{data?.notificationText}</td>
                                                                                                        <td className='text-center' style={{ border: '0px' }}>{data?.notificationDescription}</td>
                                                                                                        <td className='text-center' style={{ border: '0px' }}>{data.async ? "Yes" : "No"}</td>
                                                                                                        <td className='text-center' style={{ border: '0px' }}>{formatDateNew(data?.creationDate)}</td>

                                                                                                    </tr>
                                                                                                     :
                                                                                                     selectedListTab == "call" ?
                                                                                                    <tr key={i} style={{ borderRadius: '0px', padding: '13px', borderRadius: '0px' }}>
                                                                                                        <td className='text-center' style={{ border: '0px' }}>
                                                                                                            <div className='custom-switch2' style={{ margin: '10px 0 10px 0px' }}>
                                                                                                                <label class="switch">
                                                                                                                    <input type="checkbox" class="checkbox"
                                                                                                                        checked={data?.mapped}
                                                                                                                        onChange={(e) =>
                                                                                                                            // handleMappingValue(data, "unmapped")
                                                                                                                            handleMApPopup(true, data)
                                                                                                                        }
                                                                                                                    />
                                                                                                                    <div class="slider"></div>
                                                                                                                </label>
                                                                                                            </div>
                                                                                                        </td>
                                                                                                       
                                                                                                        <td className='text-center' style={{ border: '0px' }}>{data?.templateName}</td>
                                                                                                        <td className='text-center' style={{ border: '0px' }}>{data?.callPurpose}</td>
                                                                                                        <td className='text-center' style={{ border: '0px' }}>{data?.campaignName}</td>
                                                                                                        <td className='text-center' style={{ border: '0px' }}>{data?.leadName}</td>
                                                                                                        <td className='text-center' style={{ border: '0px' }}>{data.outbound ? "Yes" : "No"}</td>
                                                                                                        <td className='text-center' style={{ border: '0px' }}>{formatDateNew(data?.creationDate)}</td>

                                                                                                    </tr>
                                                                                                    : ''
                                                                            )) : ""}

                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div style={{ float: "right", marginTop: '20px' }}>
                                                                    <Pagination
                                                                        count={Math.ceil(popupTableData?.length / itemsPerPage)}
                                                                        page={currentPage}
                                                                        onChange={handlePopupPagePagination}
                                                                        color="primary"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <div style={{ width: '100%' }} className="text-center"><img style={{ width: '35%', marginTop: '50px', marginLeft: 'auto', marginRight: 'auto' }} src={NodataImage} /></div>
                                            }
                                        </div>
                                        {/* </AccordionDetails>
                                        </Accordion> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div style={{ width: '100%' }} className="text-center"><img style={{ width: '30%', marginTop: '50px', marginLeft: 'auto', marginRight: 'auto' }} src={NodataImage} /></div>
                }
            </div>


            {
                previewTemplate?.show ?
                    <>
                        <div className="background-blur" style={{ zIndex: '2' }}>

                            <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: '60%' }}>
                                <i onClick={() => setPreviewTemplate({ show: false, data: "", selectedata: "", type: "" })} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                                {
                                    previewTemplate?.type == "mail" ?
                                        <>
                                            <div className="row from-group">
                                                <div className="col-xs-12" style={{ padding: '10px' }}>
                                                    <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>Preview Template {`(${previewTemplate?.selectedata?.emailPath})`}</h4>
                                                </div>
                                            </div>
                                            <div style={{ backgroundColor: '#f4f4f4', padding: '10px', overflow: 'auto', maxHeight: '550px' }}>
                                                <div dangerouslySetInnerHTML={{ __html: previewTemplate?.data }}></div>
                                            </div>
                                        </>
                                        : ''}
                                {
                                    previewTemplate?.type == "sms" ?
                                        <>
                                            <div className="row from-group">
                                                <div className="col-xs-12" style={{ padding: '10px' }}>
                                                    <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>Preview Template {`(${previewTemplate?.selectedata?.dltId})`}</h4>
                                                </div>
                                            </div>
                                            <div style={{ backgroundColor: '#f4f4f4', padding: '10px', overflowX: 'hidden', maxHeight: '550px', height: '300px' }}>
                                                <div className="row">
                                                    <div className="col-xs-6" style={{ marginTop: '20px' }}>
                                                        <label htmlFor="">Description</label>
                                                        <input className='form-control' value={previewTemplate?.selectedata?.messageDescription} disabled />
                                                    </div>
                                                    <div className="col-xs-12" style={{ marginTop: '20px' }}>
                                                        <label htmlFor="">Content</label>
                                                        <textarea className='form-control' style={{ height: '150px' }} value={previewTemplate?.selectedata?.messageContent} disabled />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        : ''}
                                {
                                    previewTemplate?.type == "whatsapp" ?
                                        <>
                                            <div className="row from-group">
                                                <div className="col-xs-12" style={{ padding: '10px' }}>
                                                    <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>Preview Template {`(${previewTemplate?.selectedata?.dltId})`}</h4>
                                                </div>
                                            </div>
                                            <div style={{ backgroundColor: '#f4f4f4', padding: '10px', overflowX: 'hidden', maxHeight: '550px', height: '300px' }}>
                                                <div className="row">
                                                    <div className="col-xs-6" style={{ marginTop: '20px' }}>
                                                        <label htmlFor="">Subject</label>
                                                        <input className='form-control' value={previewTemplate?.selectedata?.whatsappSubject} disabled />
                                                    </div>
                                                    <div className="col-xs-6" style={{ marginTop: '20px' }}>
                                                        <label htmlFor="">Description</label>
                                                        <input className='form-control' value={previewTemplate?.selectedata?.whatsappDescription} disabled />
                                                    </div>
                                                    <div className="col-xs-12" style={{ marginTop: '20px' }}>
                                                        <label htmlFor="">Content</label>
                                                        <textarea className='form-control' style={{ height: '150px' }} value={previewTemplate?.selectedata?.whatsappText} disabled />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        : ''}
                                {
                                    previewTemplate?.type == "notification" ?
                                        <>
                                            <div className="row from-group">
                                                <div className="col-xs-12" style={{ padding: '10px' }}>
                                                    <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>Preview Template {`(${previewTemplate?.selectedata?.dltId})`} </h4>
                                                </div>
                                            </div>
                                            <div style={{ backgroundColor: '#f4f4f4', padding: '10px', overflowX: 'hidden', maxHeight: '550px', height: '300px' }}>
                                                <div className="row">
                                                    <div className="col-xs-6" style={{ marginTop: '20px' }}>
                                                        <label htmlFor="">Subject</label>
                                                        <input className='form-control' value={previewTemplate?.selectedata?.notificationSubject} disabled />
                                                    </div>
                                                    <div className="col-xs-6" style={{ marginTop: '20px' }}>
                                                        <label htmlFor="">Description</label>
                                                        <input className='form-control' value={previewTemplate?.selectedata?.notificationDescription} disabled />
                                                    </div>
                                                    <div className="col-xs-12" style={{ marginTop: '20px' }}>
                                                        <label htmlFor="">Content</label>
                                                        <textarea className='form-control' style={{ height: '150px' }} value={previewTemplate?.selectedata?.notificationText} disabled />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        : ''}


                            </div>
                        </div>
                    </>
                    : ''}

            {
                mapPopup?.show ?
                    <div className="background-blur">

                        <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', top: '10%', width: '80%' }}>
                            <i onClick={() => setMapPopup({ show: false, data: {} })} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>

                            <div>
                                <div className="row" style={{ marginTop: '20px' }}>
                                    {

                                        datashow == "SYSTEM_PLAN" ?
                                            <>
                                                <div className="col-sm-4 col-xs-12">
                                                    <FormControl sx={{ m: 1, width: '100%' }}>
                                                        <InputLabel id="demo-multiple-checkbox-label">Trigger Date</InputLabel>
                                                        <Select
                                                            labelId="demo-multiple-checkbox-label"
                                                            id="demo-multiple-checkbox"
                                                            value={triggerDate}
                                                            onChange={handleTriggerDateChange}
                                                            input={<OutlinedInput label="Tag" />}
                                                            renderValue={(selected) => selected.join(', ')}
                                                            MenuProps={MenuProps}
                                                        >
                                                            {names.map((name) => (
                                                                <MenuItem key={name} value={name}>
                                                                    {/* <Checkbox checked={triggerDate.includes(name)} /> */}
                                                                    <ListItemText primary={name} />
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                                <div className="col-sm-4 col-xs-12" >
                                                    <FormControl sx={{ m: 1, width: '100%' }}>
                                                        <InputLabel id="multi-time-label">Trigger Time</InputLabel>
                                                        <Select
                                                            labelId="multi-time-label"
                                                            id="multi-time-select"
                                                            multiple
                                                            value={mapdata?.triggerTime}
                                                            onChange={handleTriggerTimeChange}
                                                            input={<OutlinedInput label="Trigger Times" />}
                                                            renderValue={(selected) => selected.join(', ')}
                                                        >
                                                            {hours24?.map((hour24) => (
                                                                <MenuItem key={hour24} value={hour24}>
                                                                    <Checkbox checked={mapdata?.triggerTime?.indexOf(hour24) > -1} />
                                                                    <ListItemText primary={formatTo12Hour(hour24)} />
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                    {/* <TextField value={mapdata?.triggerTime} onChange={(e) => setMapdata((prev) => ({ ...prev, 'triggerTime': e.target.value }))} fullWidth type='time' id="outlined-basic" label="Trigger Time" variant="outlined" /> */}
                                                </div>
                                            </>
                                            : ''}
                                    {
                                        datashow == "MANUAL" ?
                                            <div className="col-sm-4 col-xs-12" style={{ marginTop: '7px' }}>

                                                <TextField value={mapdata?.executionOrder} onChange={(e) => setMapdata((prev) => ({ ...prev, 'executionOrder': e.target.value }))} fullWidth type='number' id="outlined-basic" label="Execution Order" variant="outlined" />
                                            </div>
                                            : ''}

                                </div>

                                <div className="row" style={{ marginTop: '40px' }}>
                                    <div className="col-xs-12 text-center">
                                        <button className='btn' onClick={() => handleMappingValue(mapPopup?.data, "unmapped")} style={{ padding: '10px 15px', borderRadius: '6px', background: '#1eb0d2', color: '#fff' }}>Map</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    : ''}
        </>
    )
}
